<app-skill-builder-text-list
	[mainTitle]="page.title"
	[subTitle]="subTitle"
	[validationError]="page.error"
	[textInputs]="values"
	[next]="next"
	[parentLoaded]="loaded.toPromise()"
>
</app-skill-builder-text-list>
